// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"z1-z"};